import Vue from 'vue'
export const eventBus = new Vue();
import App from './App.vue'
import store from "./store";
import router from './router'
import './libs/rem'
// import { mapMutations } from 'vuex';
// Vue.prototype.$mapMutations = mapMutations;

import Vant from 'vant';
import 'vant/lib/index.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(Vant)

Vue.config.productionTip = false


// vue原型挂载 - 是否PC端
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    Vue.prototype.$pc = false
} else {
    Vue.prototype.$pc = true
}


new Vue({
	store,
	router,
	data:function(){
		return{
			subMenuIndex: 0
		}
	},
	render: h => h(App),
}).$mount('#app')
